import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import copy from 'copy-to-clipboard';
import Button from 'components/common/Button';
import Collapsible from 'components/common/controls/Collapsible';
import Table from 'components/Credit24/Core/Table';

const propTypes = {
  customerNumber: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
};

class RepaymentInfoSection extends Component {
  copyToClipboard(value) {
    try {
      copy(value);
    } catch (e) {
      if (DEBUG) {
        console.log(e);
      }
    }
  }

  render() {
    const { formatMessage } = this.props.intl;

    const copyButton = (value) => (
      <button
        type="button"
        className="link"
        onClick={() => this.copyToClipboard(value)}
      >
        <FormattedMessage id="selfservice.repaymentInfo.dashboard.copy" />
      </button>
    );

    const tableRows = [{
      id: 'bsb',
      label: formatMessage({ id: 'selfservice.repaymentInfo.dashboard.bsb' }),
      value: formatMessage({ id: 'selfservice.repaymentInfo.dashboard.bsb.value' }),
      button: copyButton(formatMessage({ id: 'selfservice.repaymentInfo.dashboard.bsb.value' })),
    },
    {
      id: 'accountNumber',
      label: formatMessage({ id: 'selfservice.repaymentInfo.dashboard.accountNumber' }),
      value: formatMessage({ id: 'selfservice.repaymentInfo.dashboard.accountNumber.value' }),
      button: copyButton(formatMessage({ id: 'selfservice.repaymentInfo.dashboard.accountNumber.value' })),
    },
    {
      id: 'customerNumber',
      label: formatMessage({ id: 'selfservice.repaymentInfo.dashboard.reference' }),
      value: this.props.customerNumber,
      button: copyButton(this.props.customerNumber),
    }];

    return (
      <div className="content-block">
        <Collapsible
          Title={() => (
            <FormattedMessage id="selfservice.repaymentInfo.dashboard.title" tagName="h3" />
          )}
          ButtonOpen={({ onClick }) => (
            <Button btnType="secondary" onClick={onClick}>
              <FormattedMessage id="collapsible.show" />
            </Button>
          )}
        >
          <>
            <FormattedMessage id="selfservice.repaymentInfo.dashboard.description" tagName="p" />
            <Table
              rows={tableRows}
              cells={['label', 'value', 'button']}
              cssClass="table--payment-details"
            />
          </>
        </Collapsible>
      </div>
    );
  }
}

RepaymentInfoSection.propTypes = propTypes;

RepaymentInfoSection.contextTypes = {
  intl: PropTypes.object,
};

export default injectIntl(RepaymentInfoSection);
